import { Gap } from '@salecycle/ui-component-library';
import { Alert2 } from 'components/experimental/Alert/Alert2';
import { Link, useParams } from 'react-router-dom';

/*
  NOTE: No translations required - temporary alert designed
  for English-speaking users only. 
*/

export function SendRulesDisabledNotice() {
  const { siteId } = useParams<{ siteId: string }>();
  return (
    <>
      <Gap top={30} />
      <Alert2 heading="Send Rules are currently disabled" variation="warning" altBackground={true}>
        <p>
          Send Rules need to be enabled before they can be tested. You can enable them from the Send Rules section{' '}
          <Link to={`/sites/${siteId}/compliance/send-rules`}>here</Link>.
        </p>
      </Alert2>
    </>
  );
}
